import { Checkbox, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import Button from "../../shared/Button";
import Input from "../../shared/Input";
import Selectbox from "../../shared/Select";
import add from "../../../assets/img/icons/add.svg";
import { useCreatePlace } from "../../../context/CreatePlaceContext";
import WelfareForm from "./WelfareForm";
import SportForm from "./SportForm";
import useFetch from "../../../hooks/useAxios";
import { toast } from "react-hot-toast";
import { useParams } from "react-router-dom";

const CreateStep5 = ({ nextStep, prevStep }) => {
  const {
    updatePlaceDetail,
    createInfoData,
    apiUpdateResideces,
    setIsEditPlaceCompleter
  } = useCreatePlace();
  const [welfarearray, setwelfarearray] = useState([]);
  const [sportarray, setsportarray] = useState([]);
  useEffect(() => {
    setwelfarearray(createInfoData.stepSix.places.welfare);
    setsportarray(createInfoData.stepSix.places.sport);
  }, []);
  const [texture_List, setTextureList] = useState([]);
  const [baft, setbaft] = useState(createInfoData.stepSix.environment_texture);
  const [path, setPath] = useState(createInfoData.stepSix.access_path);
  const onChangebaft = e => {
    setbaft(e)
  };
  const getTexture = useFetch({
    method: "get",
    url: "api/environment_texture",
    noHeader: true,
    trigger: true,
    argFunc: res => setTextureList(res)
  });
  const place = {
    welfare: [
      {
        name: "",
        distance_by_car: "",
        walking_distance: ""
      }
    ],
    sport: [
      {
        name: "",
        distance_by_car: "",
        walking_distance: ""
      }
    ]
  };
  const masir = [
    {
      id: 1,
      label: "آسفالت ",
      value: "asphalt"
    },
    {
      id: 1,
      label: "خاکی",
      value: "dirt"
    },
    {
      id: 1,
      label: "مال رو",
      value: "road"
    }
  ];
  const onChange = e => {
    setPath(e.target.value);
  };
  console.log(baft)
  const gotonext = () => {
  
    if (baft.length === 0) {
      toast.error("بافت محیطی اجباری است.");
    } else {
      updatePlaceDetail("stepSix", {
        environment_texture: baft,
        access_path: path,
        places: {
          welfare: welfarearray,
          sport: sportarray
        }
      });
      nextStep();
    }
  };
  const { id } = useParams();
  const update = data => {
    if (baft.length === 0) {
      toast.error("بافت محیطی اجباری است.");
    } else {
      updatePlaceDetail("stepSix", {
        environment_texture: baft,
        access_path: path,
        places: {
          welfare: welfarearray,
          sport: sportarray
        }
      });
      setIsEditPlaceCompleter(true);
    }
  };
  console.log("texture_List",texture_List);
  console.log("baft",baft);
  return (
    <div className="createsteps">
      <h2>اطلاعات محیطی </h2>
      <p className="w-[100%] ">
        ظرفیت اقامتگاه را متناسب با تعداد تخت و امکانات آن در نظر بگیرید. حداکثر
        ظرفیت، مجموع ظرفیت استاندارد و نفرات اضافه است. به مهمان‌های بیشتر از
        ظرفیت استاندارد، نفرات اضافه گفته می‌شود که هزینه‌شان به صورت نفری
        محاسبه خواهد شد.
      </p>
      <div className="createsteps-choosingbox mt-[50px]">
        <h6 className="mb-[8px] text-[#292D32] text-[18px] font-[700]">
          بافت محیطی
        </h6>
         <Checkbox.Group defaultValue={baft.map(i=>i.value)} options={texture_List} onChange={onChangebaft} />
       
      </div>
      <div className="createsteps-choosingbox mt-[50px]">
        <h6 className="mb-[8px] text-[#292D32] text-[18px] font-[700]">
          {" "}مسیر دسترسی ( اختیاری )
        </h6>
        <Radio.Group
          defaultValue={createInfoData.stepSix.access_path}
          onChange={onChange}
          value={path}
        >
          <div className="grid md:grid-cols-4 grid-cols-2 md:gap-[32px] gap-[16px]">
            {masir.map(i =>
              <div
                key={i.value}
                className={`createsteps--radiogroupbox ${path === i.value
                  ? "createsteps--radiogroupbox--active"
                  : ""}`}
              >
                <Radio value={i.value}>
                  <h5 className=" whitespace-nowrap">
                    {i.label}
                  </h5>
                </Radio>
              </div>
            )}
          </div>
        </Radio.Group>
      </div>
      {welfarearray.length > 0
        ? welfarearray.map((i, index) =>
            <WelfareForm
              welfarearray={welfarearray}
              setwelfarearray={setwelfarearray}
              index={index}
            />
          )
        : place.welfare.map((i, index) =>
            <WelfareForm
              welfarearray={welfarearray}
              setwelfarearray={setwelfarearray}
              index={index}
              isFirst={true}
            />
          )}
      <Button
        varient="borderbot"
        className="mt-[20px]"
        onClick={() =>
          setwelfarearray(prev => [
            ...prev,
            {
              name: "",
              distance_by_car: "",
              walking_distance: ""
            }
          ])}
      >
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      {sportarray.length > 0
        ? sportarray.map((i, index) =>
            <SportForm
              welfarearray={sportarray}
              setwelfarearray={setsportarray}
              index={index}
            />
          )
        : place.sport.map((i, index) =>
            <SportForm
              isFirst={true}
              welfarearray={sportarray}
              setwelfarearray={setsportarray}
              index={index}
            />
          )}
      <Button
        onClick={() =>
          setsportarray(prev => [
            ...prev,
            {
              name: "",
              distance_by_car: "",
              walking_distance: ""
            }
          ])}
        varient="borderbot"
        className="mt-[20px]"
      >
        <div className="flex items-center gap-[5px]">
          <img src={add} />
          <div> افزودن مورد جدید</div>
        </div>
      </Button>
      <div className="flex create-box--button justify-end gap-[16px] w-[full] mt-[70px]">
        {id &&
          <Button varient="primary" onClick={() => update()}>
            بروزرسانی اقامتگاه
          </Button>}
        <Button
          varient="gray"
          onClick={() => {
            prevStep();
          }}
        >
          مرحله قبلی
        </Button>

        <Button varient="primary" onClick={() => gotonext()}>
          مرحله بعدی
        </Button>
      </div>
    </div>
  );
};

export default CreateStep5;
